/**
 * @Author: Tuire Nissinen
 * @Date:   2024-05-06 15:23:01
 * @Last Modified by:   Tuire Nissinen
 * @Last Modified time: 2024-10-28 14:32:10
 */
/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
/* eslint-enable no-console */
import React, { useEffect, useState } from 'react';

import { createRoot } from 'react-dom/client';
import apiFetch from '@wordpress/api-fetch';

import map from './images/map.png';
import placeholder from './images/placeholder.png';


const container = document.getElementById('LocationListingo');
const root = createRoot(container);
root.render(<LocationListingo />);

function LocationListingo() {
  const [attributes, setAttributes] = useState({
    posts: []
  });

  const [selectedPost, setSelectedPost] = useState();
  const [selectedPage, setSelectedPage] = useState(1);

  useEffect(() => {
    if (attributes.posts.length > 0) {
      changePost(0);
    }
  }, [attributes]);

  useEffect(() => {
    (async () => {
      
      const posts = await apiFetch({
        path: "/wp/v2/locations?per_page=-1&status=publish&acf_format=standard"
      });

      posts.forEach(async function (post, index) {
        post.acf.location.forEach(async function (location, index2) {
          location.featured_image = location.location_image ? location.location_image.url : placeholder;
          location.featured_image_alt = location.location_image ? location.location_image.alt : '';
        });
      });

      setAttributes({
        posts : posts,
      });
      
    })();
  }, []);

  function changePost(index) {
    setSelectedPost(attributes.posts[index]);
    setSelectedPage(index+1);
  }

  function changePage(pn) {
    changePost(pn-1);
    setSelectedPage(pn);
  }


  
  return (
    <div>
      <h2>Mehiläinens sjukhus</h2>
      <div className='wp-block-mehi-block-location-listing__map'>
        <img alt="Karta" src={map}></img>
          {attributes.posts.map((post, index) => (
            <button tabIndex={0} key={index} aria-label={post.acf.location.map(l => l.location_name).join(', ')} role='button' aria-pressed={(selectedPost && post.id==selectedPost.id) ? true : false} className={(selectedPost && post.id==selectedPost.id ? 'selected-location' : '' ) + ' wp-block-mehi-block-location-listing__map__marker'} style={{ top: post.acf.location[0].top + 'px', left: post.acf.location[0].left + 'px' }} onClick={() => changePost(index)}>
              { post.acf.location.length == 1 ? (
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 20.0005C0 8.95479 8.95431 0.000488281 20 0.000488281C31.0457 0.000488281 40 8.95479 40 20.0005C40 31.0462 31.0457 40.0005 20 40.0005C8.95431 40.0005 0 31.0462 0 20.0005Z" fill="#007E32"/>
                  <path d="M18.2494 19.6439C18.8416 18.9204 21.0534 15.9208 21.5009 15.3937C21.9594 14.8553 22.4805 14.1893 23.2452 14.1036C24.7207 13.9384 26.0786 15.1866 25.6111 17.1641C25.392 18.0932 24.1982 20.3503 24.1982 20.3503C24.9663 19.3238 26.7291 17.775 27.0903 16.7656C27.4711 15.6952 27.3497 14.525 26.5299 13.5896C25.521 12.4423 23.7772 12.3209 22.7038 13.0659C22.169 13.4356 21.7622 13.8517 21.1079 14.6936C20.5361 15.4263 17.7672 19.109 17.7658 19.1041L18.2494 19.6444V19.6439Z" fill="white"/>
                  <path d="M19.5543 15.007C18.8317 13.7671 18.1276 13.0489 17.1282 12.7074C16.7588 12.5807 15.1094 12.1559 13.8018 13.0879C11.9892 14.378 11.7872 16.6507 13.678 19.0034C15.5413 21.3219 19.6946 26.1285 20.173 26.873C20.173 26.873 21.9054 24 22.6375 22.8371C22.6375 22.8371 21.0411 24.4794 21.0146 24.5101C20.924 24.3956 15.5034 18.0046 15.2668 17.7571C13.1489 15.5263 14.1692 13.4562 15.4275 13.3344C16.664 13.2146 17.287 14.3673 17.8929 15.328C18.3557 16.0603 18.5017 16.3881 18.5065 16.3925C18.5065 16.3925 19.549 15.0172 19.5547 15.007" fill="white"/>
                  <path d="M15.6364 23.2168C13.0127 26.5238 10.4998 27.5002 10.4998 27.5002C11.8074 26.6047 13.5261 24.9254 15.1727 22.6624C15.1761 22.6624 15.6379 23.2182 15.6364 23.2168Z" fill="white"/>
                  <path d="M21.2113 17.4995C21.2289 17.5229 21.2516 17.5531 21.2806 17.5911C21.7845 18.2493 23.9954 21.0687 25.7141 22.8352C27.3498 24.516 29.2733 26.0721 30.4998 25.2385L28.4621 26.8443C26.6898 27.0709 22.6764 22.3363 20.1915 19.0186C20.1683 18.9893 20.1465 18.9582 20.1232 18.9294L21.2113 17.4995Z" fill="white"/>
                </svg>
              ) : (
                <svg width="40" height="40" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 20.7354C0 9.68966 8.95431 0.735352 20 0.735352C31.0457 0.735352 40 9.68966 40 20.7354C40 31.781 31.0457 40.7354 20 40.7354C8.95431 40.7354 0 31.781 0 20.7354Z" fill="#007E32"/>
                  <path d="M15.198 27.2354V25.4894L19.734 21.6194C21.552 20.0534 22.218 19.2074 22.218 18.0194C22.218 16.7054 21.264 15.9314 20.04 15.9314C18.798 15.9314 17.97 16.5974 16.962 17.9114L15.396 16.6874C16.638 14.9414 17.88 13.9514 20.202 13.9514C22.74 13.9514 24.486 15.5174 24.486 17.8394V17.8754C24.486 19.9274 23.424 21.0434 21.102 22.9514L18.312 25.2914H24.63V27.2354H15.198Z" fill="white"/>
                </svg>
              )}
            </button>
          ))}
      </div>
      <div className='wp-block-mehi-block-location-listing__info'>
        {selectedPost && (
          <div className='wp-block-mehi-block-location-listing__info__content-wrapper'>
          <h2>Mehiläinen hospitals</h2>
          {selectedPost.acf.location.map((location, index) => (
            <div key={'loc'+index}  className='wp-block-mehi-block-location-listing__info__content-wrapper__content'>
              <div className='wp-block-mehi-block-location-listing__info__content-wrapper__content__image'>
                <img alt={location.featured_image_alt} src={location.featured_image}></img>
              </div>
              <h3>{location.location_name}</h3>
              <div>{location.location_text}</div>
              <div className='wp-block-mehi-block-location-listing__info__content-wrapper__content__address'>{location.location_address}</div>
              <div>
                <a href={location.location_link} target="_blank">Read more about the hospital</a>
              </div>
            </div>
          ))}
          </div>
        )}
        {attributes.posts.length > 1 && (
          <div className='wp-block-mehi-block-location-listing__info__pagination'>
            <button aria-label='Previous' disabled={selectedPage==1} onClick={() => changePage(selectedPage-1)}>
              <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="ui/angle-left">
                <path id="icon" d="M16.3439 19.5025L23.2449 12.707C23.5203 12.4317 23.9655 12.4317 24.2408 12.707L24.6568 13.1229C24.9321 13.3983 24.9321 13.8435 24.6568 14.1188L18.6638 20.0005L24.6509 25.8822C24.9263 26.1575 24.9263 26.6027 24.6509 26.8781L24.235 27.294C23.9596 27.5693 23.5144 27.5693 23.2391 27.294L16.3381 20.4984C16.0686 20.2231 16.0686 19.7779 16.3439 19.5025Z" fill="#007E32"/>
                </g>
              </svg>
            </button>
            <div aria-label={'Page number ' + selectedPage}>{selectedPage + ' / ' +  attributes.posts.length}</div>
            <button aria-label='next' disabled={selectedPage==attributes.posts.length} onClick={() => changePage(selectedPage+1)}>
              <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="ui/angle-right">
                <path id="icon" d="M24.6561 20.4984L17.7551 27.294C17.4797 27.5693 17.0345 27.5693 16.7592 27.294L16.3432 26.8781C16.0679 26.6027 16.0679 26.1575 16.3432 25.8822L22.3362 20.0005L16.3491 14.1188C16.0737 13.8435 16.0737 13.3983 16.3491 13.1229L16.765 12.707C17.0404 12.4317 17.4856 12.4317 17.7609 12.707L24.6619 19.5025C24.9314 19.7779 24.9314 20.2231 24.6561 20.4984Z" fill="#007E32"/>
                </g>
              </svg>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}